import React from 'react';
import { EmptyTenant, TenantDescription } from '../api/model/TenantDescription';

export const TenantContext = React.createContext<{ tenant: TenantDescription; availableTenants: TenantDescription[] }>({
  tenant: EmptyTenant,
  availableTenants: [],
});
